var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53fb89c8","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Crm/containers/Policy.vue
// module id = null
// module chunks = 